import FreePassPromoCodeLabel from './FreePassPromoCodeLabel';

export default FreePassPromoCodeLabel;
